import React from 'react';
import { TrendingUp, Clock, Wrench, Heart, Scale, Coins } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { benefits, healthBenefits } from '../data/mock';

const iconMap = [
  TrendingUp,
  Clock,
  Wrench,
  Heart,
];

const BenefitsSection = () => {
  return (
    <section id="benefici" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
            Perché Sceglierci
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Benefici <span className="gradient-text">Economici e Sanitari</span>
          </h2>
          <p className="text-lg text-slate-600">
            Investire nella pulizia e manutenzione dei sistemi HVAC è una decisione 
            strategica che protegge la vostra azienda e garantisce un ambiente sano.
          </p>
        </div>

        {/* Economic Benefits */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-slate-800 mb-8 text-center">
            <Coins className="inline-block mr-2 text-sky-500" size={28} />
            Vantaggi Economici
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => {
              const IconComponent = iconMap[index];
              return (
                <Card
                  key={benefit.id}
                  className="relative overflow-hidden border-0 shadow-lg bg-gradient-to-br from-slate-50 to-white hover:shadow-xl transition-all duration-300"
                >
                  <CardContent className="p-6">
                    <div className="flex items-center justify-center w-12 h-12 bg-sky-100 rounded-xl mb-4">
                      <IconComponent className="w-6 h-6 text-sky-600" />
                    </div>
                    <div className="text-4xl font-bold text-sky-500 mb-2">
                      {benefit.stat}
                    </div>
                    <div className="text-sm font-semibold text-slate-700 mb-3">
                      {benefit.statLabel}
                    </div>
                    <h4 className="font-bold text-slate-800 mb-2">{benefit.title}</h4>
                    <p className="text-sm text-slate-600 mb-3">{benefit.description}</p>
                    <div className="text-xs text-slate-400 italic">
                      Fonte: {benefit.source}
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Health Benefits */}
        <div>
          <h3 className="text-2xl font-bold text-slate-800 mb-8 text-center">
            <Heart className="inline-block mr-2 text-rose-500" size={28} />
            Benefici per la Salute
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {healthBenefits.map((benefit, index) => (
              <div
                key={benefit.id}
                className="flex gap-4 p-6 bg-gradient-to-br from-rose-50 to-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-rose-100 rounded-full flex items-center justify-center text-rose-600 font-bold">
                  {index + 1}
                </div>
                <div>
                  <h4 className="font-bold text-slate-800 mb-2">{benefit.title}</h4>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center p-8 bg-gradient-to-r from-slate-800 to-slate-700 rounded-2xl">
          <p className="text-white/90 text-lg max-w-2xl mx-auto">
            Seguiamo rigorosamente le linee guida dell'<strong>OMS</strong> e del <strong>Ministero della Salute</strong> per garantire ambienti salubri e sicuri.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
